"use client";

import { del } from "idb-keyval";

const PRIVATE_LOCAL_STORAGE_KEYS = [
  /^hiive:review-draft:/,
  /^hiive:recent-locations$/,
  /^hiive\.recent-session-activities$/,
];

/** Remove browser state that must never survive an account transition. */
export async function clearPrivateBrowserState(): Promise<void> {
  const tasks: Promise<unknown>[] = [del("reactQuery")];

  if ("caches" in window) {
    try {
      const cacheNames = await window.caches.keys();
      tasks.push(
        ...cacheNames.map((cacheName) => window.caches.delete(cacheName)),
      );
    } catch {
      // CacheStorage may be unavailable in a restricted browser context.
    }
  }

  await Promise.allSettled(tasks);

  try {
    for (let index = window.localStorage.length - 1; index >= 0; index -= 1) {
      const key = window.localStorage.key(index);
      if (
        key &&
        PRIVATE_LOCAL_STORAGE_KEYS.some((pattern) => pattern.test(key))
      ) {
        window.localStorage.removeItem(key);
      }
    }
    window.sessionStorage.clear();
  } catch {
    // Storage access can be blocked by browser privacy settings.
  }
}
